 export const getMemberRequests=(state, circle_id, request_id)=>{    
    const requests = state.member_requests.requests;
    const requests_for_circle = requests[circle_id]?requests[circle_id] : undefined;
    if(request_id){        
        return requests_for_circle?requests[circle_id][request_id]:undefined;
    } 
    return requests_for_circle;    
}

export const isFetchingMemberRequests=(state)=>{
    return state.member_requests.loading;
}

export const updatingRequests=(state)=>{
    return state.member_requests.update_status;
}
 